<template>
    <div class="product_availability__wrap">
        <div v-if="isProductAvailabilityReloading || isLoading" class="awaiting_overlay displayed partial dots_loader">
            <p loader="loading"></p>
        </div>
        <div v-else ref="pa_shown">
            <div v-if="mode === 'cart-details'">
                <div v-if="!isOnlineBranch && isPart">
                    <div v-if="onHand > 0">
                        <span v-if="isBackOrdered" class="pickup_item availability backorder">Limited Inventory <button v-on:click="showAvailabilityVariesModal()" class="intext_link">(?)</button></span>
                        <span v-else class="pickup_item availability instock">In Stock</span>
                        <span class="pickup_item">
                            <strong>{{onHand}}</strong> in stock at {{myStoreName}}
                        </span>
                    </div>
                    <div v-else>
                        <span v-if="isBackOrdered" class="pickup_item availability backorder">Limited Inventory <button v-on:click="showAvailabilityVariesModal()" class="intext_link">(?)</button></span>
                        <span v-else class="pickup_item availability available">Availability varies <button v-on:click="showAvailabilityVariesModal()" class="intext_link">(?)</button></span>
                        <span class="pickup_item availability">
                            <strong>{{onHand}}</strong> in stock at {{myStoreName}}
                        </span>
                    </div>
                </div>
                <div v-else>
                    <span v-if="isBackOrdered" class="pickup_item availability backorder">Limited Inventory <button v-on:click="showAvailabilityVariesModal()" class="intext_link">(?)</button></span>
                    <span v-else-if="numberOfStoresInWhichPartIsAvailable >= 2" class="pickup_item availability instock">In Stock</span>
                    <span v-else class="pickup_item availability available">Availability varies <button v-on:click="showAvailabilityVariesModal()" class="intext_link">(?)</button></span>
                </div>
            </div>
            <div v-else-if="isPart !== true" class="pa_content_wrap">
                <span v-if="instorePickupAvailable" class="instore available">
                    In-Store Pickup Available <span class="where">at {{instorePickupAvailable}}</span>
                </span>

                <span class="pa_onsale_badge" style="display: none">On Sale</span>
            </div>
            <div v-else class="pa_content_wrap">
                <div v-if="!isOnlineBranch && !isProductAvailabilityReloading">
                    <div v-if="onHand > 0" class="pd_actions">
                        <span class="pickup_item">
                            <strong>{{onHand}}</strong> in stock at {{myStoreName}}
                        </span>
                        <br/>
                        <span v-if="isBackOrdered" class="backorder">Limited Inventory <button v-on:click="showAvailabilityVariesModal()" class="intext_link">(?)</button></span>
                        <span v-else class="instore ships instock">In Stock</span>
                        <span class="pa_onsale_badge" style="display: none">On Sale</span>
                    </div>
                    <div v-else class="pd_actions">
                        <span class="pickup_item instore" :class="{zero_stock: onHand == 0}">
                            <strong>{{onHand}}</strong> in stock at {{myStoreName}}
                        </span>
                        <span v-if="isBackOrdered" class="backorder">Limited Inventory <button v-on:click="showAvailabilityVariesModal()" class="intext_link">(?)</button></span>
                        <span v-else class="instore available ships">Availability varies <button v-on:click="showAvailabilityVariesModal()" class="intext_link">(?)</button></span>
                        <span class="pa_onsale_badge" style="display: none">On Sale</span>
                    </div>
                </div>
                <div v-else>
                    <div v-if="isBackOrdered" class="pd_actions">
                        <span class="backorder">Limited Inventory <button v-on:click="showAvailabilityVariesModal()" class="intext_link">(?)</button></span>
                    </div>
                    <div v-else-if="numberOfStoresInWhichPartIsAvailable >= 2" class="pd_actions">
                        <span class="instore ships instock">In Stock</span>
                    </div>
                    <div v-else class="pd_actions">
                        <span class="instore available ships">Availability varies <button v-on:click="showAvailabilityVariesModal()" class="intext_link">(?)</button></span>
                    </div>

                    <span class="pa_onsale_badge" style="display: none">On Sale</span>
                </div>
            </div>
        </div>

        <div class="avm_popup shown" v-if="availabilityVariesModalShown" ref="avm_popup">
            <div class="atc_body width_restricted no_padding mb_20vh_desktop">
                <button class="atc_close js_close" v-on:click.stop="hideAvailabilityVariesModal">
                    <span class="sr--only">Close</span>
                    <svg class="svg-icon" viewBox="0 0 20 20">
                        <path stroke="#333" stroke-width="2" d="M 5 5 L 15 15 M 5 15 L 15 5"></path>
                    </svg>
                </button>
                <div class="atc_title gray_title">We'll Work to Fill Your Request</div>
                <div v-if="isBackOrdered" class="avm_data">
                    This item is in high demand. Either our supply is limited, or our part vendor has limited supply.
                </div>
                <div v-else class="avm_data">
                    You have access to one of the nation’s largest parts and equipment inventories. 
                    If needed, items are transferred between stores or direct shipped to accommodate your needs.
                </div>
                <button class="styled_button yellow mb_20" v-on:click.stop="hideAvailabilityVariesModal">Close</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { Constants } from "../functions/constants";
    import { CartUtils } from "../functions/cart-utils";

    export default {
        name: "ProductAvailability",
        props: {
            isPart: {
                type: Boolean,
                default: false
            },
            isProductAvailabilityReloading: {
                type: Boolean,
                default: false
            },
            onHand: {
                type: Number,
                default: 0
            },
            numberOfStoresInWhichPartIsAvailable: {
                type: Number,
                default: 0
            },
            mode: {
                type: String,
                default: ""
            },
            instorePickupAvailable: {
                type: String,
                default: ""
            },
            primaryCta: {
                type: Object,
                default: null
            }
        },
        data: function () {
            return {
                isOnlineBranch: false,
                myStoreName: null,
                availabilityVariesModalShown: false
            }
        },
        methods: {
            updateMyStore: function (myStoreBranch) {
                if (!myStoreBranch)
                    return;

                this.myStoreName = myStoreBranch.BranchName;
                GlobalApp.MyStoreService.isMyStoreOnlineBranch().then(this.updateIsOnlineBranch);
            },
            updateMyStoreEventHandler: function (object, myStoreBranch) {
                this.updateMyStore(myStoreBranch);
            },
            updateIsOnlineBranch: function (isOnlineBranch) {
                if (isOnlineBranch === true) {
                    this.isOnlineBranch = true;
                } else {
                    this.isOnlineBranch = false;
                }
            },
            showAvailabilityVariesModal: function showAvailabilityVariesModal () {
                this.availabilityVariesModalShown = true;
                document.body.style.overflow = 'hidden';
                
                let containing_section = this.$refs.pa_shown.closest('section');
                if (containing_section) {
                    containing_section.classList.add('lifted')
                }
            },
            hideAvailabilityVariesModal: function hideAvailabilityVariesModal () {
                document.body.style.overflow = 'unset';

                let containing_section = this.$refs.pa_shown.closest('section');
                if (containing_section) {
                    containing_section.classList.remove('lifted')
                }

                this.availabilityVariesModalShown = false;
            }
        },
        computed: {
            isLoading: function () {
                if (!this.myStoreName)
                    return true;

                return false;
            },
            popupShown: function () {
                return this.addedToCartPopupShow;
            },
            productsTotalQuantity: function () {
                return CartUtils.getProductsTotalQuantity(this.cartDetail);
            },
            isBackOrdered: function () {
                if (!this.primaryCta?.text)
                    return false;

                return this.primaryCta.text === Constants.ALGOLIA.PRODUCT.CTA.DISPLAY_TEXT_BACKORDERED || this.primaryCta.text === Constants.ALGOLIA.PRODUCT.CTA.VALUE_BACKORDERED;
            }
        },
        created: function () {
            GlobalApp.MyStoreService.getMyStore().then(this.updateMyStore);
            GlobalApp.MyStoreService.isMyStoreOnlineBranch().then(this.updateIsOnlineBranch);

            GlobalApp.EventHub.subscribeToEvent(Constants.EVENTS.CART.MY_STORE_UPDATE, this.updateMyStoreEventHandler);
        },
        destroyed() {
            GlobalApp.EventHub.unsubscribeToEvent(Constants.EVENTS.CART.MY_STORE_UPDATE, this.updateMyStoreEventHandler);
        }
    };
</script>